import { getStandorte } from '../../../helpers/getStandorte';
import { getVeranstaltungen } from '../../../helpers/getVeranstaltungen';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';

export function getLastDataYear(max: number, dataIn: any, params?: any, callback?: (data: any) => void): number {
    const data: any = dataIn || {};
    const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
    const min: number = +startjahr > 1900 ? startjahr : 2010;
    let jahr: number = null;
    params = params || {};
    const energietraeger: number = +params.energietraeger || null;
    const entities: string[] = (params.entities || []).length
        ? params.entities
        : [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME];
    const invalidData: boolean = typeof params.invalidData === 'boolean' ? params.invalidData : false;
    const isCO2Scope3: boolean = typeof params.isCO2Scope3 === 'boolean' ? params.isCO2Scope3 : false;
    const standorte: any[] = [...(getStandorte(data) || []), ...(getVeranstaltungen(data) || [])].map((standort: any) => standort.tid);
    let standort: number = +params.standort || null;

    if ((+max || 0) <= min) {
        return null;
    }

    for (let curJahr: number = max; curJahr >= min; --curJahr) {
        if (jahr) {
            break;
        }
        entities.forEach((entity: string) => {
            const keys: string[] = [];
            if (isCO2Scope3) {
                (data[IDs.ENT_CO2_SCOPE3_AUSWAHL] || []).forEach((item: any) => {
                    if (item.auswahl === 1 && item.jahr === curJahr && item.name && `co2_scope3_${item.name}` === entity
                        && item.name !== 'brennstoff' && (item.standort_tid_orig || item.standort_tid)
                    ) {
                        keys.push(item.standort_tid_orig || item.standort_tid);
                    }
                });
            }
            let sortedData: any[] = [];
            standorte.forEach((standort_tid: number) => {
                const dataEntity: any[] = (data[entity] || []).filter((item: any) =>
                    (item.standort_tid_orig || item.standort_tid) === standort_tid && item.jahr === curJahr
                    && (!standort || (item.standort_tid_orig || item.standort_tid) === standort)
                    && (!energietraeger || (item.energietraeger_tid_orig || item.energietraeger_tid) === energietraeger)
                    && (!isCO2Scope3 || keys.indexOf(item.standort_tid_orig || item.standort_tid) !== -1 || entity === 'co2_scope3_emittenten')
                    && (invalidData || isValid(item, entity))
                );
                sortedData = [...sortedData, ...dataEntity];
            });
            sortedData.forEach((item: any) => {
                if (jahr === null) {
                    jahr = curJahr;
                    standort = !standort ? item.standort_tid_orig || item.standort_tid : standort;
                    if (typeof callback === 'function') {
                        callback({ jahr, standort });
                    }
                }
            });
        });
    }
    return jahr;
}
